<template>
    <el-dialog title="输入网址上传素材" custom-class="network-upload-dialog" @click.native.stop
               width="730px" :lock-scroll="false" :close-on-click-modal="false" @close="onClose"
               :visible.sync="dialogVisible" :append-to-body="true" >
        <el-form ref="myForm" :model="myForm" :rules="myFormRules" label-width="100px" label-position="top">
            <el-form-item prop="url" label="网址上传">
                <el-input v-model="myForm.url" @click.native.stop placeholder="http://www.xxx.com/xxx/xxx.png" @keyup.enter.native="onConfirm"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="onConfirm" :loading="submitLoading">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
    import templateService from '../../../request/service/template-service';
    export default  {
        name: 'network-upload-dialog',
        props: {
            value: {
                type: Boolean,
                default: false
            },
        },
        data () {
            let checkImgUrl = (rule, value, callback) => {
                let isHttp = value.startsWith('http://') || value.startsWith('https://');
                if(isHttp){
                    let url = new window.URL(value);
                    let pathname = url.pathname;
                    if(pathname.endsWith('.png') || pathname.endsWith('.jpg') || pathname.endsWith('.jpeg')){
                        callback();
                        return;
                    }
                }
                callback(new Error('请输入后缀是.png或.jpg的图片网址'));
            };
            return {
                submitLoading: false,
                myForm:{
                    url: ''
                },
                myFormRules:{
                    url: [
                        { required: true, message: '网络地址不能为空', trigger: 'blur' },
                        { validator: checkImgUrl,trigger: 'blur' }
                    ],
                },
                networkImgUrl: ''
            };
        },
        computed: {
            dialogVisible:{
                get () {
                    return this.value;
                },
                set (v) {
                    this.$emit('input', v);
                }
            }
        },
        mounted(){
        },
        methods: {
            onConfirm() {
                this.$refs['myForm'].validate((valid) => {
                    if (valid) {
                        this.getNosImgData(this.myForm.url);
                    } else {
                        return false;
                    }
                });
            },
            getNosImgData(url) {
                this.submitLoading = true;
                templateService.getNosImgUrlByNetworkImg(url).then((data) => {
                    this.$emit('success', data);
                    this.$emit('input', false);
                }).finally(() => {
                    this.submitLoading = false;
                });
            },
            onClose() {
                this.$refs['myForm'].resetFields()
            }
        }
    }
</script>